//@flow
import * as Immutable from 'immutable';
import moment from 'moment-timezone';
import I18nHelper from 'common/helpers/I18nHelper';

import { ExpiryNotification } from 'common/models/flow/ExpiryNotification';
import type { ExpiryNotificationModelType } from 'common/models/flow/ExpiryNotification';

import TimeUtils from 'common/utils/TimeUtils';
import DataUtils from 'common/utils/DataUtils';

import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';

const translationsNamespace = ['contracts'];
const nsTranslate = I18nHelper.translate.bind(null, translationsNamespace);

@validatable
class InternalExpiryNotification extends ExpiryNotification {
    static fromJS(
        json: ExpiryNotificationModelType
    ): InternalExpiryNotification {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setStartDate(startDate: string): this {
        return this.clone(this._state.set('startDate', startDate));
    }

    validateStartDate(): string {
        const { startDate } = this;
        const startMoment = moment(startDate);

        if (DataUtils.isEmpty(this.startDate) || !startMoment.isValid()) {
            return nsTranslate('contracts:validationErrors.invalidStartDate');
        }

        const endError = this.validateEndDate();
        if (endError) {
            return endError;
        }
        if (
            !DataUtils.isEmpty(startDate) &&
            !DataUtils.isEmpty(endError) &&
            TimeUtils.isAfter(
                startMoment,
                endError.add(this.get('endDayOffset'), 'd')
            )
        ) {
            return nsTranslate(
                'contracts:validationErrors.startTimeAfterEndTime'
            );
        }
    }

    @validate
    setEndDate(endDate: string): this {
        return this.clone(this._state.set('endDate', endDate));
    }

    validateEndDate(): string {
        const endMoment = moment(this.endDate);
        if (DataUtils.isEmpty(this.endMoment) || !endMoment.isValid()) {
            return nsTranslate('contracts:validationErrors.invalidEndDate');
        }
    }
}

export { InternalExpiryNotification as ExpiryNotification };
